import { http, HttpResponse } from 'msw'

export const mockUpdateCustomerAdditionalContact = http.put(
  '/my-business/api/agency/v1/customers/additional-contacts/:additionalContactAlphaId',
  () => {
    return HttpResponse.json(
      { timestamp: new Date().toISOString() },
      { status: 200 },
    )
  },
)
